<template>
  <div>
    <van-popup v-model="isShow" position="bottom" @click-overlay="onCancel">
      <van-datetime-picker v-model="currentDate" :min-date="minDate" :max-date="maxDate" type="datetime" :formatter="formatter" @cancel="onCancel" @confirm="onConfirm" />
    </van-popup>
  </div>
</template>

<script>
import utils from '@/utils/tradeDataUtil'
export default {
  name: 'Time',
  props: ['show'],
  data() {
    return {
      isShow: this.show,
      currentDate: new Date(),
      minDate: new Date(utils.getDay(-6)),
      maxDate: new Date()
    }
  },
  methods: {
    formatter(type, value) {
      return value
    },
    onCancel() {
      this.isShow = false
      this.$emit('cancel', this.isShow)
    },
    onConfirm(value) {
      this.isShow = false
      this.$emit('cancel', this.isShow)
      this.$emit('change', value)
    }
  }
}
</script>
